module.exports = __webpack_public_path__ + "img/925.b478f139.png";